module.exports = __webpack_public_path__ + "static/media/FolderBlueLight.e4c2a445.svg";